import React, { useState } from 'react'
import { Dialog } from '../components/ui/dialog'
import { Table } from '../components/ui/Table'
import { useSelector } from 'react-redux'
import { axiosGet } from '../util/api'
import { Filters } from '../config'
import { Link } from 'react-router-dom'
import { format } from 'date-fns'
import { ActionsToText } from '../types/bulk_action_log'
import { Layout } from '../components/Layout'
import { useTableHooks } from '../packages/blueprint-components/src/useTableHooks'
import { State } from '../reducers'
import { Tooltip } from '../components/ui/tooltip'
import { UpdateReportAdTypes } from '../util/contstants'
import { BreadcrumbProps } from '@blueprintjs/core'
import type { EntityId } from '../types/constants'

const resolveLink = (type: number, id: number): string => {
    switch (type) {
        case UpdateReportAdTypes.Campaigns:
            return `/campaigns/${id}`
        case UpdateReportAdTypes.AdGroups:
            return `/ad-groups/${id}`
        case UpdateReportAdTypes.ProductAds:
            return `/product-ads/${id}`
        case UpdateReportAdTypes.Keywords:
            return `/keywords/${id}`
        case UpdateReportAdTypes.Targets:
            return `/targets/${id}`
        default:
            console.warn('Cannot resolve link for type', type, id)
            return ''
    }
}

interface BulkActionLogsProps {
    targetId?: number
    targetType?: number
}

export const BulkActionLogs = ({ targetId, targetType }: BulkActionLogsProps) => {
    const [modal, setModal] = useState(null)
    const breadcrumbs: BreadcrumbProps[] = [
        { text: 'Overview' },
        { href: '/combined-history', text: 'History' },
    ]

    const profile = useSelector<State, EntityId | null>((state) => state.user.profile)
    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return axiosGet('bulk-actions', {
            ...params,
            filter: {
                ...params.filter,
                target_type_id: params.filter?.target_type_id || targetType,
                target_id: params.filter?.target_id || targetId,
            },
        })
    }
    const tableHooks = useTableHooks(load)

    const columns = [
        {
            key: 'created_at',
            title: 'Date',
            sortable: false,
            formatter: (v: string) => format(new Date(v), 'M/d/yy H:mm a'),
        },
        {
            key: 'effected',
            title: 'Effected Entities',
            sortable: false,
            cell: (log: any) => (
                <Tooltip
                    interactionKind="hover"
                    position="right"
                    hoverCloseDelay={100}
                    content={
                        <div>
                            {log.effected.sort().map((id: number) => (
                                <div key={id}>
                                    <Link to={resolveLink(log.for, id)}>{id}</Link>
                                </div>
                            ))}
                        </div>
                    }
                >
                    <div>
                        {log.effected?.length} {log.for_string}
                    </div>
                </Tooltip>
            ),
        },
        {
            key: 'action',
            title: 'Event',
            sortable: false,
            cell: (log: any) => <Action log={log} />,
        },
    ]

    const tableOptions = {
        name: 'Bulk Action Logs',
        showHeader: false,
        tableHooks: tableHooks,
        filters: targetType && targetId ? null : filters,
        dateSelect: true,
        columns: columns,
        onSelectChange: null,
        selectKey: 'campaign_id',
    }

    return (
        <Layout breadcrumbs={breadcrumbs} primary="Bulk Action Logs">
            {/*
        // @ts-ignore */}
            <Table {...tableOptions} />
            <Dialog isOpen={!!modal} onClose={() => setModal(null)} className="p-4">
                {modal}
            </Dialog>
        </Layout>
    )
}

const filters = [
    Filters.EffectedEntityId,
    Filters.EffectedEntityType,
    Filters.SourceTypeId,
    // Filters.State,
    // Filters.TargetingType,
    // Filters.DailyBudget,
    // ...PerformanceFilters,
]

const Action = ({ log }: { log: any }) => {
    if (!log.actions) {
        return <div>-- unknown --</div>
    }
    return <div>{ActionsToText(log)}</div>
}
